





















/* Created- 19 - Aug - 2019 */
import { Component, Vue, Prop } from "vue-property-decorator";
import ParticaCardDialog from "../Common/Container/ParticaDialogCard.vue";
import { IssueStorageDTO } from "../../Generated/ParticaAPI";
import { DateUtils } from "../../BusinessServices/dateutils";
@Component(
	{
		name: "IssueStatusLog",
		components: { ParticaCardDialog }
	})
export default class IssueStatusLog extends Vue {
	@Prop() private data: IssueStorageDTO[]; // your data   
	private showstats: boolean = false;
	private search: string = "";
	private headers: any[] = [
		{ text: "Time", value: "timestamp", sortable: true },
		{ text: "Status", value: "status", sortable: true },
		{ text: "User", value: "user", sortable: true },
	];
	private getFormat(date: Date) {
		return date.toISOString();
	}
}



